import React from "react";
import { useEffect, useState } from 'react';
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

export const NotasNoTimbradosSection = ({ data }) => {
    const [notas, setNotas] = useState([]);

    useEffect(() => {
        setNotas(data);
    }, [data]);

    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table>
                    <thead>
                        <tr>
                            <th>
                                Sucursal
                            </th>
                            <th>
                                <div>Departamento</div>
                            </th>
                            <th>
                                <div>Cuenta</div>
                            </th>
                            <th>
                                <div>Documento</div>
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Tipo de Comprobante</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                            <th>
                                <div>UUID</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {notas.map((nota, i) => (
                            <tr key={i}>
                                <td className="ta-center">{capitalizePalabras(nota.sucursal)}</td>
                                <td className="ta-center">{capitalizePalabras(nota.departamento)}</td>
                                <td className="ta-center">{nota.cuenta}</td>
                                <td className="ta-center">{nota.documento}</td>
                                <td className="ta-center">{new Date(nota.fecha).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}</td>
                                <td className="ta-right">{FormatMoney(nota.importe)}</td>
                                <td className="ta-center">{nota.serie_fiscal}</td>
                                <td className="ta-center">{nota.folio_fiscal}</td>
                                <td className="ta-center">{capitalizePalabras(nota.tipoComprobante)}</td>
                                <td className="ta-center">{nota.batch}</td>
                                <td className="ta-center">{nota.uuid}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
